import AddCroppedImage from "components/bootstrap/AddCroppedImage";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import CustomTextArea from "components/Form/TeaxtAreaBootstrap";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormStepsProps } from "../FormStepsProps";

const RoadProblemSection = ({
  control,
  errors,
  canvasImages,
  currentCroppedButton,
  setCurrentCroppedButton,
  addCroppedImageArray,
  setValue,
}: FormStepsProps) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col md={8}>
        <Controller
          name="roadProblemDescription"
          control={control}
          render={({ field: { onChange } }) => (
            <CustomTextArea
              name="roadProblemDescription"
              control={control}
              errors={errors.roadProblemDescription}
              label={t("roadProblemDescription")}
              maxLength={100}
              required
            />
          )}
        />
      </Col>
      {addCroppedImageArray
        .filter((cropped) => cropped.name === "roadProblemPicture")
        .map((image) => {
          return (
            <Col md={4} className="h-100" key={image.name}>
              <Controller
                name={image.name}
                control={control}
                render={({ field: { onChange, value: roadProblemValue } }) => (
                  <Form.Label className="text-area-report-details full-width-label">
                    <p className=" text-truncate">
                      {t("cutTheProblemFromMovie")}
                    </p>
                    <AddCroppedImage
                      className="cropped-image-container fixed-height relative"
                      src={image.src}
                      text={image.text}
                      backgroundColor={image.backgroundColor}
                      name={image.name}
                      canvasImages={canvasImages[image.name]}
                      setCurrentCroppedButton={setCurrentCroppedButton}
                      currentCroppedButton={currentCroppedButton}
                      addCroppedImageArray={addCroppedImageArray}
                      setValue={setValue}
                      value={roadProblemValue}
                    />
                  </Form.Label>
                )}
              />
            </Col>
          );
        })}
    </Row>
  );
};
export default RoadProblemSection;
